// removed by extract-text-webpack-plugin
module.exports = {"metaCol":"MediaEditorContainer-module__metaCol___2SKXG"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MediaEditorContainer/MediaEditorContainer.module.sass
// module id = 1085
// module chunks = 0